import { render } from "./orderFollowUp.vue?vue&type=template&id=6e87e296&scoped=true"
import script from "./orderFollowUp.vue?vue&type=script&lang=js"
export * from "./orderFollowUp.vue?vue&type=script&lang=js"

import "./orderFollowUp.vue?vue&type=style&index=0&id=6e87e296&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e87e296"]])

export default __exports__